import React, { useEffect, useState } from "react";

type ProgressBarProps = {
  // When false: bar moves slowly and stops around 85-90 percent
  // When true: bar quickly fills to 100 percent
  isComplete?: boolean;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ isComplete = false }) => {
  const [progress, setProgress] = useState(8); // small head start so it does not feel stuck at 0

  // Phase 1 - slow steady progress up to about 90 percent
  useEffect(() => {
    if (isComplete) return; // stop this phase once we are in "finish" mode

    const id = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev; // cap around 90 while backend works
        return Math.min(prev + 1.5, 90);
      });
    }, 120); // smooth updates

    return () => clearInterval(id);
  }, [isComplete]);

  // Phase 2 - once isComplete is true, push quickly to 100 percent
  useEffect(() => {
    if (!isComplete) return;

    const id = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(id);
          return 100;
        }
        return Math.min(prev + 5, 100);
      });
    }, 80);

    return () => clearInterval(id);
  }, [isComplete]);

  return (
    <div className="w-full max-w-xl mx-auto mt-4">
      <div className="h-2 rounded-full bg-gray-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-[#005FCC] transition-[width] duration-150 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
